import { observable, action, computed } from "mobx";

export class DownloadState {
  @action
  public reset() {
    this.hasReceivedProgess = false;
    this.isFileChecked = false;
    this.bytesWritten = 0;
    this.totalBytes = 0;
    this.error = undefined;
    this.completed = false;
  }

  @observable
  public hasReceivedProgess = false;

  public readonly totalBytesEstimated: boolean;

  /**
   * @param totalBytes Total bytes that need to be downloaded. Used to calculate the progress.
   * When totalBytes 0 is supplied `isEstimated` class property will be set to true.
   * You can then call updateEstimate(percentage) to update totalBytes with an estimation
   */
  constructor(totalBytes = 0) {
    this.totalBytes = totalBytes;

    this.totalBytesEstimated = !this.totalBytes;
  }

  @computed
  public get progress() {
    if (this.completed) return 100;
    else return (this.bytesWritten / this.totalBytes) * 100;
  }

  @action
  public updateEstimate(percentage: number) {
    if (!this.totalBytesEstimated) return;
    this.totalBytes = this.bytesWritten / (percentage / 100);
  }

  /**
   * Number of bytes currently written
   */
  @observable
  public bytesWritten = 0;

  @action
  public setBytesWritten(written: number) {
    this.bytesWritten = written;

    if (!this.hasReceivedProgess) this.hasReceivedProgess = true;
  }

  /**
   * Total bytes to be downloaded
   */
  @observable
  public totalBytes: number;

  @action
  public setTotalBytes(total: number) {
    // Do not set totalbytes if it's smaller than 0
    if (!total || total < 0) return;
    this.totalBytes = total;
  }

  @action
  public setWrittenAndTotalBytes(written: number, total: number) {
    this.setBytesWritten(written);
    this.setTotalBytes(total);
  }

  @observable
  public error?: Error;

  @action
  public setError(error?: Error) {
    this.error = error;
  }

  @observable
  public completed = false;

  @action
  public setCompleted(size?: number) {
    this.completed = true;

    if (size) this.setWrittenAndTotalBytes(size, size);
    else this.setBytesWritten(this.totalBytes);

    if (!this.hasReceivedProgess) this.hasReceivedProgess = true;
  }

  @observable
  public isFileChecked = false;

  @action
  public setIsFileChecked(value: boolean) {
    this.isFileChecked = value;
  }
}
